<template>
  <div class="d-flex">
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45.5 8.75H10.5C9.5335 8.75 8.75 9.5335 8.75 10.5V45.5C8.75 46.4665 9.5335 47.25 10.5 47.25H45.5C46.4665 47.25 47.25 46.4665 47.25 45.5V10.5C47.25 9.5335 46.4665 8.75 45.5 8.75Z"
        stroke="#AFAFAF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.5 5.25V12.25"
        stroke="#AFAFAF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.5 5.25V12.25"
        stroke="#AFAFAF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.75 19.25H47.25"
        stroke="#AFAFAF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>
